/** Maximum single image file size in bytes (250MB) */
export const MAX_IMAGE_FILE_SIZE = 250 * 1024 * 1024;

/** Maximum ZIP file size in bytes (500MB) */
export const MAX_ZIP_FILE_SIZE = 500 * 1024 * 1024;

/** Human-readable max image file size for display */
export const MAX_IMAGE_FILE_SIZE_LABEL = '250MB';

/** Maximum number of images per catalog item (per Updated-upload-object mockup). */
export const MAX_IMAGES_PER_ITEM = 20;
